import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {SelectItem} from '../../../../dtos/SelectItem';

@Component({
  selector: 'core-input-dropdown',
  templateUrl: 'input-dropdown.component.html',
  styleUrls: ['input-dropdown.component.scss', '../core-input.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: InputDropdownComponent,
    multi: true
  }]
})
export class InputDropdownComponent implements ControlValueAccessor, OnInit {

  @Input() id: string;
  @Input() label: string;
  @Input() floatLabel: string;
  @Input() topLabel: string;
  @Input() placeholder: string = '';
  @Input() showClearButton: boolean = true;

  @Input() removeDefaultBottomErrorMargin: boolean = false;
  @Input() binaryOptions: { name: string, id: boolean }[] = [{name: 'Ja', id: true}, {name: 'Nein', id: false}];
  @Input() binary: boolean = false;
  @Output() onKeyUpEnter = new EventEmitter<string>();
  control: NgControl;
  value: string;
  disabled = false;
  private onTouched: Function;
  private onChanged: Function;

  constructor(private inj: Injector) {
    if (!this.id) {
      this.id = 'core-input-dropdown-' + Math.random();
    }
  }

  _options: SelectItem[] = [];

  @Input() set options(options: SelectItem[]) {
    if (!options) {
      options = [];
    }
    this._options = options.map(o => {
      const option = o;
      if (!option.name) {
        return null;
      }
      option.name = option.name.length > 50 ? option.name.substr(0, 50) + '...' : option.name;
      return option;
    });
  }

  ngOnInit() {
    this.control = this.inj.get(NgControl)
  }

  onClear() {
    this.valueChanged(null);
    this.onKeyUpEnter.emit(null)
  }

  valueChanged(value: string) {
    this.onTouched();
    this.value = value;
    this.onChanged(value);
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

}
